module.exports = __webpack_public_path__ + "static/careplus-dca89e5c766e5bbcf32d8d09ade3bccb.png";